import type { DashboardMessageId } from "./dashboard.fr";

/** Tableau de bord in European Portuguese. Same keys and {placeholders} as dashboard.fr.ts. */
export const dashboardPt: Record<DashboardMessageId, string> = {
  "dashboard.greeting": "Olá, {name}",
  "dashboard.subtitle": "{date} · Conacri",
  "dashboard.generatedAt": "Números lidos às {time} (até um minuto de desfasamento).",
  "dashboard.refresh": "Atualizar",
  "dashboard.refreshing": "A atualizar…",
  "dashboard.loading": "A carregar o painel…",
  "dashboard.loadFailed": "Não foi possível carregar o painel.",
  "dashboard.alertsAria": "A tratar agora",
  "dashboard.alert.open": "Abrir →",
  "dashboard.alert.critical_report_open.tag": "Crítico",
  "dashboard.alert.critical_report_open.text": "{count} denúncia(s) crítica(s) aberta(s).",
  "dashboard.alert.critical_report_open.review":
    "{count} pessoa(s) suspensa(s) até decisão da equipa; primeira revisão a fazer antes de {date}.",
  "dashboard.alert.suspension_review_overdue.tag": "Revisão em atraso",
  "dashboard.alert.suspension_review_overdue.text":
    "{count} suspensão(ões) ultrapassaram o prazo de revisão (a mais antiga: {date}). As pessoas continuam suspensas até à sua decisão.",
  "dashboard.alert.cases_past_deadline.tag": "Atraso",
  "dashboard.alert.cases_past_deadline.text":
    "{count} processo(s) ultrapassaram o prazo de primeira resposta ({hours} h).",
  "dashboard.alert.thin_coverage.tag": "Oferta",
  "dashboard.alert.thin_coverage.text":
    "{trade} em {city}: {requests} pedidos hoje para {pros} profissional(is) disponível(is). É aí que é preciso recrutar.",
  "dashboard.alert.failed_payments.tag": "Pagamentos",
  "dashboard.alert.failed_payments.text": "{count} pagamento(s) Orange Money falhado(s) hoje.",

  "dashboard.card.demand": "Pedidos do dia",
  "dashboard.card.demand.answered": "Respondidos em menos de {hours} h",
  "dashboard.card.demand.unanswered": "Sem resposta",
  "dashboard.card.demand.expired": "Expirados",
  "dashboard.card.introductions": "Contactos estabelecidos",
  "dashboard.card.introductions.quotes": "Orçamentos enviados",
  "dashboard.card.introductions.median": "Tempo mediano até à primeira resposta",
  "dashboard.card.introductions.cancelled": "Cancelados antes do contacto",
  "dashboard.card.pros": "Profissionais verificados",
  "dashboard.card.pros.unit": "ativos",
  "dashboard.card.pros.new": "Novos em 7 dias",
  "dashboard.card.pros.waiting": "A aguardar verificação",
  "dashboard.card.pros.suspended": "Suspensos",
  "dashboard.card.money": "Taxas cobradas",
  "dashboard.card.money.failed": "Pagamentos Orange Money falhados",
  "dashboard.card.money.approvals": "Pedidos de aprovação pendentes",
  "dashboard.card.money.subscriptions": "Assinaturas mensais ativas",

  "dashboard.coverage": "Cobertura por profissão e comuna",
  "dashboard.coverage.empty": "Nenhum pedido hoje.",
  "dashboard.coverageFoot": "A vermelho: menos de metade dos pedidos respondidos a tempo. É aí que é preciso recrutar.",
  "dashboard.col.trade": "Profissão",
  "dashboard.col.commune": "Comuna",
  "dashboard.col.requests": "Pedidos",
  "dashboard.col.pros": "Profissionais disp.",
  "dashboard.col.answered": "Respondidos < {hours} h",

  "dashboard.queues": "Filas de espera",
  "dashboard.noQueues": "Nenhuma fila para as suas funções.",
  "dashboard.queue.late_cases": "Processos em atraso",
  "dashboard.queue.open_cases": "Processos abertos",
  "dashboard.queue.open_cases.meta": "{count} não atribuído(s)",
  "dashboard.queue.identity_verifications": "Verificações de identidade",
  "dashboard.queue.identity_verifications.meta": "a mais antiga aguarda há {age}",
  "dashboard.queue.safety_reports": "Denúncias abertas",
  "dashboard.queue.severity.critical": "{count} crítica(s)",
  "dashboard.queue.severity.high": "{count} alta(s)",
  "dashboard.queue.severity.medium": "{count} média(s)",
  "dashboard.queue.severity.low": "{count} baixa(s)",
  "dashboard.queue.overdue_suspension_reviews": "Revisões de suspensão em atraso",
  "dashboard.queue.overdue_suspension_reviews.meta": "ainda suspensos até decisão",
  "dashboard.queue.payment_approvals": "Pedidos de aprovação",
};
